import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'
import { ARROW_SVG } from './MangaSlider'

export class MangaModalSlider {
  constructor() {
    this.slidersEl = [...document.getElementsByClassName('js-manga-modal-slider')]
    if (this.slidersEl.length === 0) return

    this.sliders = this.slidersEl.map((sliderEl) => this.initSlider(sliderEl))
  }
  initSlider(sliderEl) {
    sliderEl.classList.add('keen-slider')
    const slides = [...sliderEl.children]
    slides.forEach((slide) => slide.classList.add('keen-slider__slide'))

    const prevButton = this.createNavButton('prev', '前のページへ')
    const nextButton = this.createNavButton('next', '次のページへ')
    // 端まで来た側のボタンは非表示にする（1ページ目は next だけ表示）
    const updateNav = (s) => {
      const { rel, minIdx, maxIdx } = s.track.details
      prevButton.disabled = rel <= minIdx
      nextButton.disabled = rel >= maxIdx
    }

    const slider = new KeenSlider(sliderEl, {
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        perView: 1,
      },
      defaultAnimation: {
        duration: 600,
      },
      created: (s) => {
        prevButton.addEventListener('click', () => s.prev())
        nextButton.addEventListener('click', () => s.next())

        const nav = document.createElement('div')
        nav.className = 'p-index_manga-modal__nav'
        nav.append(prevButton, nextButton)
        s.container.parentNode.appendChild(nav)

        updateNav(s)
      },
      slideChanged: updateNav,
      updated: updateNav,
    })

    this.observeDialog(sliderEl, slider)

    return slider
  }
  createNavButton(direction, label) {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = `p-index_manga-modal__nav__button -${direction}`
    button.setAttribute('aria-label', label)
    button.innerHTML = ARROW_SVG
    return button
  }
  // dialog は閉じている間サイズを持たないので、開くたびに再計測して1ページ目に戻す
  observeDialog(sliderEl, slider) {
    const dialog = sliderEl.closest('dialog')
    if (!dialog) return

    const observer = new MutationObserver(() => {
      if (!dialog.open) return
      slider.update(undefined, 0)
    })
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] })
  }
}
